import { Request, Response, Middleware } from "../common";

export class UnauthorizedMiddleware implements Middleware {
  constructor(private readonly callback: () => void) { }

  async onRequest(request: Request, next: () => Promise<Response>): Promise<Response> {
    try {
      const response = await next();
      return response;
    } catch (e: any) {
      if (e?.response?.status === 401) {
        this.callback();
      }
      throw e;
    }
  }
}
